export const COMPACT_GLOBAL_NAVBAR_LOGO_SIZE_CLASS = "h-10 w-10";

export const COMPACT_GLOBAL_NAVBAR_AVATAR_SIZE_CLASS = "!h-10 !w-10";

export const COMPACT_GLOBAL_NAVBAR_ICON_SIZE_PX = 22;

export const COMPACT_GLOBAL_NAVBAR_ADD_ICON_SIZE_PX = Math.round(COMPACT_GLOBAL_NAVBAR_ICON_SIZE_PX * 1.2);

export const compactGlobalNavbarIconBoxClassName = "inline-flex size-10 shrink-0 items-center justify-center";

/** Compact Search / Add / Tasks sit edge to edge so the 40px hit areas do not add extra air. */
export const compactGlobalToolbarIconClusterGapClassName = "gap-0";

/** Tight space between the compact icon cluster and the avatar. */
export const compactGlobalToolbarActionsGapClassName = "gap-1";

export const COMPACT_GLOBAL_TOOLBAR_CONTROL_HEIGHT_PX = 40;

export const compactGlobalToolbarControlClassName = "h-10 min-h-10";

export const COMPACT_TOP_ACTION_BAR_STICKY_OFFSET_REM = 7.5;

/**
 * Sticky `top` in rem for chrome that sits below the always-compact TopActionBar.
 * DevBanner is in document flow above the bar, so it adds height until the page
 * has scrolled and the banner has left the viewport.
 */
export function compactTopActionBarStickyOffsetRem({
  showDevBanner,
  isScrolled
}: {
  showDevBanner: boolean;
  isScrolled: boolean;
}): number {
  if (!showDevBanner) return COMPACT_TOP_ACTION_BAR_STICKY_OFFSET_REM;
  return isScrolled ? COMPACT_TOP_ACTION_BAR_STICKY_OFFSET_REM : 11;
}

/**
 * In-flow top margin for sticky chrome below the TopActionBar. Sticky `top` only shifts an
 * element within its parent, which is only as tall as the page content, so on short pages
 * the offset is clamped and the chrome rides up under the bar. Reserving the same gap in
 * flow keeps the resting position at the sticky offset regardless of content height.
 * DevBanner sits in flow above the bar, so its height is already below the parent's top.
 * Tailwind only generates literal class names, so 7.5rem must match
 * COMPACT_TOP_ACTION_BAR_STICKY_OFFSET_REM by hand.
 */
export const compactTopActionBarRestingMarginTopClassName =
  "mt-[max(0px,calc(7.5rem_-_var(--app-topbar-height,_7.5rem)))]";

export const globalToolbarBorderlessTriggerClassName = [
  "border-0 bg-transparent",
  "transition-colors",
  "hover:bg-sys-brand-on-surface/5",
  "active:bg-sys-brand-on-surface/10",
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sys-brand-primary focus-visible:ring-offset-1"
].join(" ");
